import './App.css';
import AppRoute from './AppRoute';
import { MyContextProvider } from './Context/AppContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <MyContextProvider>
      <AppRoute />
      <ToastContainer />
    </MyContextProvider>
  );
}

export default App;